import { EventItem, EventType, Tracker } from "./interfaces";

export const getEventNameForTracker = (event: EventType, tracker: Tracker) => {
  switch (event) {
    case EventType.ADD_CART:
      if (tracker === Tracker.GA || tracker === Tracker.GTAG) {
        return "add_to_cart";
      } else if (tracker === Tracker.FBP || tracker === Tracker.TIK) {
        return "AddToCart";
      }
      return EventType.ADD_CART;

    case EventType.checkout:
      if (tracker === Tracker.GA || tracker === Tracker.GTAG) {
        return "begin_checkout";
      } else if (tracker === Tracker.FBP || tracker === Tracker.TIK) {
        return "InitiateCheckout";
      }
      return EventType.checkout;

    case EventType.purchase:
      if (tracker === Tracker.GA || tracker === Tracker.GTAG) {
        return "purchase";
      } else if (tracker === Tracker.FBP) {
        return "Purchase";
      } else if (tracker === Tracker.TIK) {
        return "CompletePayment";
      }
      return EventType.purchase;

    case EventType.VIEW_CONTENT:
      if (tracker === Tracker.GA || tracker === Tracker.GTAG) {
        return "view_item";
      } else if (tracker === Tracker.FBP || tracker === Tracker.TIK) {
        return "ViewContent";
      }
      return EventType.VIEW_CONTENT;

    case EventType.view_item_list:
      if (tracker === Tracker.GA || tracker === Tracker.GTAG) {
        return "view_item_list";
      } else if (tracker === Tracker.FBP || tracker === Tracker.TIK) {
        return "ViewContentList";
      }
      return EventType.view_item_list;

    case EventType.ADD_BILLING:
      if (tracker === Tracker.GA || tracker === Tracker.GTAG) {
        return "add_payment_info";
      } else if (tracker === Tracker.FBP || tracker === Tracker.TIK) {
        return "AddPaymentInfo";
      }

    // new evwnts for GA and GTM
    case EventType.view_cart:
    case EventType.remove_from_cart:
    case EventType.add_shipping_info:
    case EventType.userLogin:
    case EventType.search_event:
    case EventType.maillist_conversion:
    default:
      return event;
  }
};

export const getCartItemFromProductToEvent = (item: EventItem) => {
  return {
    type: item.type,
    inner_id: item.inner_id,
    name: item.name,
    discount: item.discount,
    id: item.id,
    price: item.price,
    quantity: item.quantity,
    others: {
      attrs_values: item.attrs_values,
    },
    parent: item.parent,
    categories_names: item?.categories_names,
  };
};
